
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { debounce } from "lodash";

@Component
export default class PiSearch extends Vue {
  @Prop({ default: "" }) value!: string;
  @Prop({ default: "Search..." }) placeholder!: string;
  @Prop({ default: 300 }) debounceMs!: number;
  @Prop({ default: false }) block!: boolean;

  private emit = debounce((v: string) => this.$emit("input", v), 300);

  public onInput(v: string): void {
    this.emit(v);
  }
}
